import { Link } from "react-router";
import { ChevronLeft, ChevronRight, Ticket, User } from "lucide-react";
import { useSidebar } from "../hooks/contexts/useSidebar";

const navItems = [
  { id: 1, label: "Tickets", icon: <Ticket size={18} />, href: "/tickets" },
  { id: 2, label: "Users", icon: <User size={18} />, href: "/users" },
];

const AppSidebar = () => {
  const { isExpanded, isHovered, setIsHovered, toggleSidebar } = useSidebar();

  return (
    <aside
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative flex flex-col border-r border-gray-200 h-screen text-sm transition-all duration-300 ease-in-out`}
    >
      <div
        className={`absolute rounded-4xl bg-gray-100 top-2 -right-2.5
      ${
        isHovered
          ? "opacity-100 translate-x-0"
          : "opacity-0 -translate-x-1 pointer-events-none"
      }
      `}
      >
        <button
          onClick={() => toggleSidebar()}
          className="p-1 text-gray-500 hover:text-blue-600 cursor-pointer"
        >
          {isExpanded ? <ChevronLeft size={15} /> : <ChevronRight size={15} />}
        </button>
      </div>

      {/* Menu */}
      <nav className="flex-1 mt-10 overflow-y-auto px-1">
        {navItems.map((item) => (
          <Link
            key={item.id}
            to={item.href}
            className={`flex items-center gap-2 px-2 py-2 rounded-md text-gray-700 hover:bg-blue-50 hover:text-blue-600 ${
              isExpanded ? "" : "justify-center"
            }`}
          >
            <span className="w-5 h-5 flex items-center justify-center text-gray-500">
              {item.icon}
            </span>
            <span
              className={`whitespace-nowrap overflow-hidden transition-all duration-300
    ${isExpanded ? "opacity-100 max-w-xs" : "opacity-0 max-w-0"}`}
            >
              {item.label}
            </span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export { AppSidebar };
